<template>
  <section class="gf-list-grid-controller-static">
    <gf-list-grid-controller @update="onGridControllerUpdate" />
  </section>
</template>

<script>
import GfListGridController from '@/shared-modules/shared-components/shared/GfListGridController';

export default {
  name: 'GfListGridControllerStatic',
  components: { GfListGridController },
  props: {
    controlledElementId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      controlledElement: null
    };
  },
  methods: {
    onGridControllerUpdate(data) {
      this.controlledElement = document.getElementById(this.controlledElementId);
      if (this.controlledElement) {
        if (data === 'columns') {
          this.controlledElement.classList.remove('--list');
          this.controlledElement.classList.add('--columns');
        } else {
          this.controlledElement.classList.remove('--columns');
          this.controlledElement.classList.add('--list');
        }
      }
    }
  }
};
</script>
